import LoggedMiddleware from "../../middlewares/LoggedMiddleware";
import CompanyMiddleware from "../../middlewares/CompanyMiddleware";
import AdminMiddleware from "../../middlewares/AdminMiddleware";
import AdminCompaniesView from "../../views/admin/companies";
import AdminHomeView from "../../views/admin/home";
import AdminTranslations from "../../views/admin/translations";
import AdminNetworks from "../../views/admin/networks";
import AdminSmartContracts from "../../views/admin/smart-contracts";
import AdminSourceCode from "../../views/admin/source-code";
import AdminAbis from "../../views/admin/abis";
import AdminCompaniesInfo from "../../views/admin/companies/info";
import AdminRamp from "../../views/admin/ramp";
import RampSessions from "../../views/admin/ramp-session";
import InvitationMiddleware from "../../middlewares/InvitationMiddleware";

export default [
  {
    name: 'Admin Home',
    layout: '/admin',
    path: '/home',
    component: AdminHomeView,
    middlewares: [InvitationMiddleware, LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Companies',
    layout: '/admin',
    path: '/companies',
    component: AdminCompaniesView,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Companies',
    layout: '/admin',
    path: '/companies/:companyId',
    component: AdminCompaniesInfo,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware],
  },
  {
    name: 'Admin Networks',
    layout: '/admin',
    path: '/networks',
    component: AdminNetworks,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Smart Contracts',
    layout: '/admin',
    path: '/smart-contracts',
    component: AdminSmartContracts,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Source Code',
    layout: '/admin',
    path: '/source-code',
    component: AdminSourceCode,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin ABIs',
    layout: '/admin',
    path: '/abis',
    component: AdminAbis,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Ramp',
    layout: '/admin',
    path: '/ramp',
    component: AdminRamp,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Ramp Sessions',
    layout: '/admin',
    path: '/ramp-sessions',
    component: RampSessions,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  },
  {
    name: 'Admin Translations',
    layout: '/admin',
    path: '/translations',
    component: AdminTranslations,
    middlewares: [LoggedMiddleware, CompanyMiddleware, AdminMiddleware]
  }
];
